import { isObject } from "./validators";
var pendingCounter = null;
var hasPrerender = function(obj) {
    return "prerender" in obj && isObject(obj.prerender) && "pageHasFinishedRendering" in obj.prerender && typeof obj.prerender.pageHasFinishedRendering === "function";
};
export var setIsPending = function(value) {
    var counter = pendingCounter !== null && pendingCounter !== void 0 ? pendingCounter : 0;
    pendingCounter = value ? counter + 1 : counter - 1;
};
export var notifyPageReady = function() {
    if (!hasPrerender(window)) return;
    var checkRender = function() {
        if (pendingCounter === 0) {
            pendingCounter = null;
            if (hasPrerender(window)) {
                var _window_prerender;
                (_window_prerender = window.prerender) === null || _window_prerender === void 0 ? void 0 : _window_prerender.pageHasFinishedRendering();
            }
        } else if (pendingCounter === null) {
            setTimeout(function() {
                if (pendingCounter === null) {
                    pendingCounter = 0;
                }
            }, 2.5 * 1000); // LCP is 2.5s, we expect the page to be rendered by then
            requestAnimationFrame(checkRender);
        } else {
            requestAnimationFrame(checkRender);
        }
    };
    requestAnimationFrame(checkRender);
};

//# sourceMappingURL=mfa.js.map